@if (refund.tracking_id && !isOrderSummaryPage) {
    <div class="space-between show-order-details" (click)="showOrderDetails()">
        Show Order Details
        @if (!fetchOrderInProgress) {
            <mat-icon class="icon" aria-hidden="true">keyboard_arrow_right</mat-icon>
        }
        @if (fetchOrderInProgress) {
            <div>
                <div class="loader" style="width: 20px">
                    <svg class="circular" viewBox="25 25 50 50">
                        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10" />
                    </svg>
                </div>
            </div>
        }
    </div>
}

<div class="bill-details">
    <div class="space-between">
        <span class="bill-details-left"> REFUND STATUS </span>
        <span
            class="refund-status"
            [attr.data-state]="
                refund.status === 0 ? 'initial' : refund.status === refund.refund_states.length - 1 ? 'last' : 'middle'
            ">
            {{ refund.refund_states[refund.status] }}
        </span>
    </div>
    <div class="space-between">
        <span class="bill-details-left"> LAST UPDATED </span>
        <span class="order-date">
            {{ refund.last_updated * 1000 | date: 'dd MMM - h:mm a' }}
        </span>
    </div>
    @if (refund.payment_mode; as paymentMode) {
        <div class="space-between">
            <span class="bill-details-left">
                {{ paymentMode }}
            </span>
            <span class="refund-amount"> ₹{{ refund.amount }} </span>
        </div>
    }
    @if (refund.credit; as creditAmount) {
        <div class="space-between">
            <span class="bill-details-left">
                Credits
                <img src="{{ DEPLOY_URL }}/assets/icons/checkmark_teal.svg" width="12" height="12" style="margin-left: 4px" />
            </span>
            <span class="refund-amount"> ₹{{ creditAmount }} </span>
        </div>
    }
</div>

<div class="refund-states-wrapper center">
    @for (status of refund.refund_states; track status; let i = $index) {
        <div class="refund-state">
            <span class="refund-status-label title-case">
                {{ status }}
            </span>
            <div class="refund-progress" [style.background]="i <= refund.status ? '#1daaaa' : '#D8DADF'"></div>
        </div>
    }
</div>
@if (refund.remark || refund.rrn) {
    <div class="refund-details">
        <span class="remark">
            {{ refund.remark }}
        </span>
        @if (refund.rrn; as rrn) {
            <button class="rrn space-between" (click)="copyCode(refund.rrn)">
                {{ rrn }}
                <img class="code-copy" src="{{ DEPLOY_URL }}/assets/images/offer-details-copy.svg" />
            </button>
        }
    </div>
}

@if (refund.show_support_strip) {
    <div class="rrn space-between" style="margin-top: 12px" (click)="sendMailToUs()">
        <span class="facing-issue"> Facing issues? Reach out to us. </span>
        <mat-icon aria-hidden="true" class="icon">keyboard_arrow_right</mat-icon>
    </div>
}

@if (isOrderSummaryPage) {
    <div style="padding: 10px; border-bottom: 1px solid #f2f4f4"></div>
}
